import React from "react";
import BlogItem from "../../components/BlogItem/BlogItem";
import classes from "./BlogsListing.module.css";
import CardPlaceHolder from "../../components/CardPlaceHolder";
import Slider from "react-slick";
import { useHomeBlogsListing } from "../../Pregrine/HomeBlogsListing/useBlogsListing";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import swipeCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import "swiper/modules/navigation/navigation.min.css";
swipeCore.use([Navigation, Pagination, Scrollbar, A11y]);

const HomeBlogsListing = () => {
  const talonProps = useHomeBlogsListing();
  const { BlogsData } = talonProps;

  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: BlogsData && BlogsData.length > 3,
  };

  return (
    <section className={`${classes.bg_grey} pt-3 pb-3  home_Blogs`}>
      <div className="container">
        <div className="row">
          <div className={`${classes.title} text-center pb-2 `}>
            Ideas for Magical Interiors
          </div>
        </div>

        {BlogsData && BlogsData.length ? (
          <>
            <div className={`row pb-2 ${classes.desktop}`}>
              <Slider {...settings}>
                {BlogsData.map((blogItem, index) => (
                  <BlogItem blogItem={blogItem} key={index} />
                ))}
              </Slider>
            </div>
            <div className={`${classes.mobile}`}>
              <div className="slider2">
                <div className="swiper-container1">
                  <Swiper
                    slidesPerView={1}
                    navigation
                    scrollbar={{ draggable: true }}
                  >
                    {BlogsData.map((blogItem, index) => (
                      <SwiperSlide key={index}>
                        <BlogItem blogItem={blogItem} key={index} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row mt-4">
              <div className="col-md-4 col-sm-6">
                <CardPlaceHolder />
              </div>
              <div className="col-md-4 col-sm-6 d-none d-sm-block">
                <CardPlaceHolder />
              </div>
              <div className="col-md-4 d-none d-md-block">
                <CardPlaceHolder />
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default HomeBlogsListing;
